/*--BrowserRouter--*/
import { Link } from 'react-router';
import { BrowserRouter, Routes, Route } from "react-router-dom";

/*--strony--*/

import Blog from "./blog.js";
import Dom from "./dom.js";
import Praca from "./praca.js";
import Teren from "./teren.js";
import Droga from "./droga.js";
import Album from "./gallery.js";
import Story from "./story.js";
import ScrollToTop from "../ScrollToTop.jsx";


/*--css--*/

import '../assets/css/App.css';
import Header from './header.js';
import Footer from './footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--cows on main--*/

import img1 from '../assets/img/apteczka.webp';
import img2 from '../assets/img/img20.webp';
import img3 from '../assets/img/img12.webp';

import video from '../assets/video/help3.webm';
import video1 from '../assets/video/help3.mp4';

import dom from '../assets/img/img14.webp';
import praca from '../assets/img/img11.webp';
import teren from '../assets/img/img7.webp';
import droga from '../assets/img/zasilanie.jpg';
import pic1 from '../assets/img/img1.webp';
import pic2 from '../assets/img/img8.webp';
import pic3 from '../assets/img/img15.webp';
import pic4 from '../assets/img/img3.webp';
import pic5 from '../assets/img/img12.webp';
import short1 from '../assets/img/shortDom.webp';
import short2 from '../assets/img/shortPraca.webp';
import short3 from '../assets/img/shortTeren.webp';
import short4 from '../assets/img/short4.jpg';


/*========------------========*/
/*========------------========*/
/*------Header and Welcome------*/
/*========------------========*/
/*========------------========*/


function Welcome() {
  return (
    <>
      {/*==Welcome==*/}
      <article className='Welcome'>
        <Header />
        <Text />
      </article>
    </>
  );
}

function Text() {
  return (
    <>
      {/*==Text and button in Welcome==*/}
      <Container className='PageDesc' fluid>
      <img
        src="/preloady/background.webp"
        fetchPriority="high"
        decoding="async"
        alt=""
        style={{ display: 'none' }}
      />
        <Row>
          <Col lg={12}>
            <h1>Gotowi na wszystko</h1>
          </Col>
          <Col lg={12}>
            <a href='#About'>
              <button>Sprawdź sam &#8594;</button>
            </a>
          </Col>
        </Row>
      </Container>
    </>
  );
}


/*========------------========*/
/*========------------========*/
/*------SectionOne------*/
/*========------------========*/
/*========------------========*/

function SectionOne() {
  return (
    <>
      {/*====Section1====*/}
      <section className='sectionOne' id='About'>
        <Row>
          {/*==Text in SectionOne==*/}
          <Col lg={4} md={12} xs={12} className='secText'>
            <div>
              <p>
                Specjalizujemy się w sprzęcie medycznym, który chroni życie i zdrowie. Apteczki, maseczki, gaśnice. Wszystko, co niezbędne w nagłych sytuacjach. Postaw na bezpieczeństwo i gotowość.</p>
            </div>
          </Col>
          {/*==Images in SectionOne==*/}
          <Col lg={8} md={12} xs={12} className='secImages'>
            <div className='setImg'>
                {/*--first img--*/}
                <div className='pic1'>
                  <img src={img1} alt="first cow img in SectionOne"  id="img1" />
                </div>
                {/*--second img--*/}
                <div className='pic2'>
                  <img src={img2} alt="second cow img in SectionOne" id="img2"/>
                </div>
                {/*--third img--*/}
                <div className='pic3'>
                  <img src={img3} alt="third cow img in SectionOne" id="img3"/>
                </div>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*------SectionTwo------*/
/*========------------========*/
/*========------------========*/

function SectionTwo() { 
  return (
    <>
      {/*====Section2====*/}
      <section className='sectionTwo'>
        <Row>
          {/*--Video--*/} 
          <Col lg={7} md={12} xs={12} className='videoContainer'>
            <video className='video' autoPlay loop muted playsInline>
                <source src={video} type="video/webm" />
                <source src={video1} type="video/mp4" /> 
            </video>
          </Col>
          {/*--Text--*/}
          <Col lg={5} md={12} xs={12} className='secTextTwo'>
            <div>
              <div className='before'>
                <h2 className='uno'>Bezpieczni</h2>
                <h2 className='tres'>każdego dnia</h2>
              </div>
              <div className='after'>
                <h2>Bezpieczni na co dzień</h2>
              </div>
              <p>
              Niezawodny w trudnych warunkach. Nasz sprzęt medyczny powstał z myślą o wymagających użytkownikach i realnych zagrożeniach. Sprawdzony, trwały, gotowy do działania zawsze wtedy, gdy go potrzebujesz.
              </p>
            </div>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*--------SectionThree--------*/
/*========------------========*/
/*========------------========*/


function Offerts({Changing}) {
  return (
    <>
      <section className='offerts' id='Products'>
        <div>
          <h2>Odkryj zastosowania</h2>
        </div>
        <Row>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/ratunek">
              <div className="OffertContainer">
              <img onLoad={Changing} src={teren} alt="sticks" className='bigsize' id="sticks"/>
              <img onLoad={Changing} src={short3} alt="sticks" className='smallsize' id="short1"/>
              {/*--text on the picture--*/}
              <div className="textOnPic">
                <p>Ratunek</p>
              </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/ochrona">
              <div className="OffertContainer">
                <img onLoad={Changing} src={praca} alt="meat" className='bigsize' id="meat"/>
                <img onLoad={Changing} src={short2} alt="meat" className='smallsize' id="short2"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Ochrona</p>
                </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/zaplecze">
              <div className="OffertContainer">
                <img onLoad={Changing} src={dom} alt="wine" className='bigsize' id="wine"/>
                <img onLoad={Changing} src={short1} alt="wine" className='smallsize' id="short3"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Zaplecze</p>
                </div>
              </div>
            </Link>
          </Col>
          <Col lg={3} md={6} xs={12} className='contImg'>
            <Link to="/zasilanie">
              <div className="OffertContainer">
                <img onLoad={Changing} src={droga} alt="tour" className='bigsize' id="highlader"/>
                <img onLoad={Changing} src={short4} alt="tour" className='smallsize' id="short4"/>
                {/*--text on the picture--*/}
                <div className="textOnPic">
                  <p>Zasilanie</p>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*------SectionFourth------*/
/*========------------========*/
/*========------------========*/

function Gallery({Changing}) {
  return (
    <>
      <section className='Gallery'>
        <Row>
          {/*--column one--*/}
            <Col lg={4} md={6}>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                <Link to="/album">
                  <img onLoad={Changing} src={pic1} alt='krowa1' id="pic1"/>
                </Link>
                </Col>
              </Row>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic2} alt='krowa2' id="pic2"/>
                  </Link>
                </Col>
              </Row>
              {/*-button-*/}
              <Row>
                <Col>
                  <Link to="/album">
                    <button>Zobacz więcej &#8594;</button>
                  </Link>
                </Col>
              </Row>
            </Col>
          {/*--column two--*/}
            <Col lg={4} md={6}>
              {/*-img-*/}
              <Row className='radius'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic3} alt='krowa3' id="pic3"/>
                  </Link>
                </Col>
              </Row>
            </Col>
          {/*--column three--*/}
            <Col lg={4} md={12} className='Col3'>
              {/*-img-*/}
              <Row className='radius secondoff'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic4} alt='krowa4' id="pic4"/>
                  </Link>
                </Col>
              </Row>
              <Row className='firstoff'>
                <Col>
                  <Link to="/album">
                    <img onLoad={Changing} src={pic5} alt='krowa5' id="pic5"/>
                  </Link>
                </Col>
              </Row>
            </Col>
        </Row>
      </section>
    </>
  );
}

/*========------------========*/
/*========------------========*/
/*-------All functions------*/
/*========------------========*/
/*========------------========*/

function App() {
  return (
    <>
      <Welcome />
      <article className='AllSections'>
        <SectionOne />
        <SectionTwo />
        <Offerts/>
        <Gallery/>
      </article>
      <Footer/>
    </>
  );
}

function Navigator() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/ratunek" element={<Dom />} />
        <Route path="/ochrona" element={<Praca />} />
        <Route path="/zaplecze" element={<Teren />} />
        <Route path="/zasilanie" element={<Droga />} />
        <Route path="/album" element={<Album /> } />
        <Route path="/story/:id" element={<Story />} />
      </Routes>
    </BrowserRouter>
  );
}

export default Navigator;
